import { OTLink } from '../../../components/tag/OTLink';

const VideoConferenceLink = (props) => {
  const { children, link, onClick } = props;

  return (
    <OTLink isExternal link={link} onClick={onClick} target={'_blank'}>
      <i className="card-icon fa fa-laptop" />
      {children}
    </OTLink>
  );
};

export default VideoConferenceLink;
